import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import './Hero.css';

// 处理开发环境和生产环境的路径差异
const getImagePath = (filename) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}/images/轮播图/${filename}`;
};

const cacheBuster = Date.now();
const carouselImages = [
  `${getImagePath('1.png')}?v=${cacheBuster}`,
  `${getImagePath('2.png')}?v=${cacheBuster}`,
  `${getImagePath('3.png')}?v=${cacheBuster}`
];
// 调试：打印路径信息
console.log('PUBLIC_URL:', process.env.PUBLIC_URL);
console.log('轮播图片路径:', carouselImages);
console.log('当前工作目录:', window.location.origin);

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
      </div>

      <div className="container">
        <div className="hero-content">          
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            电牙 = 录音笔 + 翻译机 + 高精准AI语音识别、总结
          </motion.h1>
          
          
          <motion.div
            className="hero-media-inline"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <div className="carousel-container">
              <AnimatePresence mode="wait">
                <motion.img
                  key={currentSlide}
                  src={carouselImages[currentSlide]}
                  alt={`产品展示 ${currentSlide + 1}`}
                  className="carousel-image"
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.5 }}
                  onError={(e) => {
                    console.error('图片加载失败:', carouselImages[currentSlide]);
                    console.error('完整错误信息:', e);
                    e.target.style.border = '2px solid red';
                    e.target.style.minHeight = '200px';
                    e.target.style.background = 'rgba(255,0,0,0.1)';
                  }}
                  onLoad={() => {
                    console.log('图片加载成功:', carouselImages[currentSlide]);
                  }}
                />
              </AnimatePresence>
              
              <button className="carousel-button carousel-prev" onClick={prevSlide}>
                <ChevronLeft size={24} />
              </button>
              <button className="carousel-button carousel-next" onClick={nextSlide}>
                <ChevronRight size={24} />
              </button>

              <div className="carousel-dots">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>
            </div>
          </motion.div>
          
        </div>
      </div>

      {/* 浮动动画元素 */}
      <div className="floating-elements">
        <motion.div
          className="floating-circle circle-1"
          animate={{
            y: [-20, 20, -20],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "linear",
          }}
        />
        <motion.div
          className="floating-circle circle-2"
          animate={{
            y: [20, -20, 20],
            rotate: [360, 180, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "linear",
          }}
        />
        <motion.div
          className="floating-circle circle-3"
          animate={{
            y: [-15, 15, -15],
            rotate: [0, 270, 360],
          }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "linear",
          }}
        />
      </div>
    </section>
  );
};

export default Hero; 